import { render } from "./CheckoutCard.vue?vue&type=template&id=1244e53d"
import script from "./CheckoutCard.vue?vue&type=script&lang=js"
export * from "./CheckoutCard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/hypergen.be/pcz.hypergen.be/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__